import { Divider, Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Input,
  InputAuto,
  InputImg,
  InputSwitch,
} from "../../controls";
import { Model, UseForm } from "../../hooks";
import { Alert, Form, Tabs } from "../../layout";
import { Currencies } from "../../hooks/Currencies";
import { Countries } from "../../hooks/Countries";
import { API, actions, endpoints } from "../../api/api";
import { RmvEmptyProp, ToFormData } from "../../hooks/Method";
import { AppContext } from "../../App";
import { useTranslation } from "react-i18next";

const AddEditBranch = (props) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);
  const { setBranches, branch } = useContext(AppContext);
  const { BranchMdl } = Model();

  const {
    values,
    errors,
    setErrors,
    handleInpChg,
    handleInpCheck,
    setValues,
    handleFile,
  } = UseForm(BranchMdl);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    id &&
      API(endpoints.Branch + actions.GetById).getById(id, (res) => {
        if (res && res.status === 200) {
          var val = RmvEmptyProp(res.result);
          setValues((x) => ({ ...x, ...val }));
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    branch.id &&
      API(endpoints.City + actions.GetAllByOrg).getById(
        branch.orgId,
        (res) =>
          res &&
          res.status === 200 &&
          setCities([...res.result.map((j) => ({ ...j, label: j.name }))])
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const validateForm = () => {
    let temp = {};
    temp.name = values.name !== "" ? "" : t("ValBranch");
    temp.currency = values.currency !== "" ? "" : t("ValCurrency");
    temp.country = values.country !== "" ? "" : t("ValCountry");
    temp.phone = values.phone !== "" ? "" : t("ValPhone");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res) {
          if (res.status === 201 || res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("Success"),
              subTitle: `${t("Branch")} ${id ? t("Update") : t("Added")} ${t(
                "Successfully"
              )}.`,
              onClick: () => navigate("/branches"),
            });
            if (setBranches && res.result) {
              id
                ? setBranches((x) => [
                    ...x.map((j) =>
                      j.id === res.result.id
                        ? { ...res.result, label: res.result.name }
                        : j
                    ),
                  ])
                : setBranches((x) => [
                    ...x,
                    { ...res.result, label: res.result.name },
                  ]);
            }
          } else
            setAlert({
              isOpen: true,
              type: "error",
              title: t("Error"),
              subTitle: res.msg,
            });
        }
      };
      if (values.id === 0) {
        API(endpoints.Branch + actions.Post).post(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
      } else {
        API(endpoints.Branch + actions.Put).put(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
      }
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="mb-10 d-flex j-between a-center pt-15 pl-15 pr-15">
            <div>
              <h1
                className="form-title mb-5 fw-4 gray-color tx-upp
                    border-left"
              >
                {id ? t("Edit") : t("Add")} {t("Branch")}
              </h1>
            </div>

            <div>
              <Button type="submit" loading={loading}>
                {id ? t("SaveChanges") : t("Submit")}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="pl-15 pr-15 pb-15">
            <Tabs
              className="mt-30"
              header={[
                { label: t("GeneralFields"), icon: "" },
                { label: t("AdditionalFields"), icon: "" },
              ]}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Input
                    label={t("BranchName")}
                    name="name"
                    value={values.name}
                    error={errors.name}
                    required={true}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputAuto
                    label={t("Country")}
                    name="country"
                    value={values.country}
                    error={errors.country}
                    required={true}
                    onChange={handleInpChg}
                    options={Countries}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputAuto
                    label={t("Currencies")}
                    name="currency"
                    value={values.currency}
                    error={errors.currency}
                    required={true}
                    onChange={handleInpChg}
                    options={Currencies.map((j) => ({
                      label: `${j.id} (${j.symbol_native}) - ${j.name}`,
                      ...j,
                    }))}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Input
                    label={t("Phone")}
                    name="phone"
                    value={values.phone}
                    error={errors.phone}
                    required={true}
                    onChange={handleInpChg}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={2.5}>
                      <Input
                        label={t("FreezeFees")}
                        name="reezeFees"
                        placeholder="$ 0.00"
                        value={values.reezeFees}
                        error={errors.reezeFees}
                        type="number"
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12} md={2.5}>
                      <Input
                        label={t("EnrollmentFees")}
                        name="enrollmentFees"
                        placeholder="$ 0.00"
                        value={values.enrollmentFees}
                        error={errors.enrollmentFees}
                        type="number"
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12} md={2.5}>
                      <Input
                        label={t("TransferFees")}
                        name="transferFees"
                        placeholder="$ 0.00"
                        value={values.transferFees}
                        error={errors.transferFees}
                        type="number"
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12} md={4.5}>
                      <Input
                        label={t("Email")}
                        name="email"
                        placeholder="example@email.com"
                        value={values.email}
                        error={errors.email}
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Input
                        label={t("Website")}
                        name="website"
                        placeholder="www.sitename.com"
                        value={values.website}
                        error={errors.website}
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Input
                        label={t("MachineIP")}
                        name="machineIP"
                        value={values.machineIP}
                        error={errors.machineIP}
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Input
                        label={t("ServerIP")}
                        name="serverIP"
                        value={values.serverIP}
                        error={errors.serverIP}
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Input
                        label={t("TaxNo")}
                        name="taxNo"
                        value={values.taxNo}
                        error={errors.taxNo}
                        onChange={handleInpChg}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <InputAuto
                        label={t("City")}
                        name="cityId"
                        value={values.cityId}
                        error={errors.cityId}
                        onChange={handleInpChg}
                        options={cities}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Input
                        label={t("State")}
                        name="state"
                        value={values.state}
                        error={errors.state}
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Input
                        label={t("Address")}
                        name="address"
                        value={values.address}
                        error={errors.address}
                        onChange={handleInpChg}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputSwitch
                        label={t("AUTOEMAILSEND")}
                        name="autoEmail"
                        fontSize="16px"
                        checked={JSON.parse(values.autoEmail)}
                        onChange={handleInpCheck}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputSwitch
                        label={t("BIOMETRIC_INTEGRATION")}
                        name="biometric"
                        fontSize="16px"
                        checked={JSON.parse(values.biometric)}
                        onChange={handleInpCheck}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={3}>
                  <InputImg
                    label={t("Logo")}
                    name="logoFile"
                    src={values.logo}
                    rmv={() => {
                      setValues({ ...values, logoFile: "", logo: "" });
                    }}
                    onChange={handleFile}
                    error={errors.logoFile}
                  />
                </Grid>
              </Grid>
            </Tabs>
          </div>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AddEditBranch;
